import Swiper from 'swiper/bundle';
export default function partnerSwiper() {

    let swiper = new Swiper(".partner-swiper", {
        rewind: true,
        spaceBetween: 50,
        navigation: {
            nextEl: ".partner-swiper__button-next",
            prevEl: ".partner-swiper__button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            751: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            }
        }
    });
}